import { CanConsumptionMessages, TranslationCanConsumptionMessages } from "../interfaces/canConsumptionMessages";

const canConsumptionMessages: TranslationCanConsumptionMessages = {
  [CanConsumptionMessages.menu]: "Telemetria CAN",
  [CanConsumptionMessages.title]: "Telemetria CAN",
  [CanConsumptionMessages.tabDashboard]: "Painel",
  [CanConsumptionMessages.tabSyntheticReport]: "Relatório sintético",
  [CanConsumptionMessages.tabAnalyticReport]: "Relatório analítico",
  [CanConsumptionMessages.tabGraph]: "Gráfico CAN",

  [CanConsumptionMessages.volumeCarriedColumn]: "Volume Transportado (m³)",

  [CanConsumptionMessages.filterPeriod]: "Período de análise",
  [CanConsumptionMessages.filterPreset7Days]: "Últimos 7 dias",
  [CanConsumptionMessages.filterPreset3Days]: "Últimos 3 dias",
  [CanConsumptionMessages.filterPreset1Day]: "Último dia",
  [CanConsumptionMessages.filterPresetCustom]: "Personalizado",
  [CanConsumptionMessages.filterDateFrom]: "De",
  [CanConsumptionMessages.filterDateTo]: "até",
  [CanConsumptionMessages.filterPlants]: "Central",
  [CanConsumptionMessages.filterVehicleTypes]: "Tipo de equipamento",
  [CanConsumptionMessages.filterAllVehicleTypes]: "Todos",
  [CanConsumptionMessages.filterAlertLimits]: "Limites de alerta",
  [CanConsumptionMessages.filterPlantsPlural]: "Centrais",
  [CanConsumptionMessages.filterVehicleTypesPlural]: "Tipos de equipamento",

  [CanConsumptionMessages.periodSummary]: "{{vehicles}} equipamentos · {{travels}} viagens",
  [CanConsumptionMessages.periodConsolidatingWarning]:
    "O período termina em dias que ainda estão consolidando: a integração das notas leva 1 a 2 dias e o volume desses dias ainda pode subir.",
  [CanConsumptionMessages.periodNoData]: "Nenhum dado de consumo para o período e os filtros selecionados.",

  [CanConsumptionMessages.metricLitersPerM3Label]: "Consumo médio por m³",
  [CanConsumptionMessages.metricLitersPerM3Short]: "Consumo por m³",
  [CanConsumptionMessages.metricLitersPerM3Unit]: "L/m³",
  [CanConsumptionMessages.metricKmPerLiterLabel]: "KMs por litro",
  [CanConsumptionMessages.metricKmPerLiterShort]: "KM por litro",
  [CanConsumptionMessages.metricKmPerLiterUnit]: "km/L",
  [CanConsumptionMessages.metricLitersPerTravelLabel]: "Consumo médio por viagem",
  [CanConsumptionMessages.metricLitersPerTravelShort]: "Consumo por viagem",
  [CanConsumptionMessages.metricLitersPerTravelUnit]: "L/viagem",
  [CanConsumptionMessages.metricLitersPerHourLabel]: "Consumo médio por hora",
  [CanConsumptionMessages.metricLitersPerHourShort]: "Consumo por hora",
  [CanConsumptionMessages.metricLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.metricIdleLitersPerHourLabel]: "Marcha lenta",
  [CanConsumptionMessages.metricIdleLitersPerHourShort]: "Marcha lenta",
  [CanConsumptionMessages.metricIdleLitersPerHourUnit]: "L/h",
  [CanConsumptionMessages.hintLowerIsBetter]: "quanto menor, melhor",
  [CanConsumptionMessages.hintHigherIsBetter]: "quanto maior, melhor",

  [CanConsumptionMessages.zoneOk]: "dentro do limite",
  [CanConsumptionMessages.zoneWarn]: "em faixa de atenção",
  [CanConsumptionMessages.zoneCritical]: "acima do limite crítico",
  [CanConsumptionMessages.gaugeThresholds]: "atenção {{warn}} · crítico {{critical}}",
  [CanConsumptionMessages.gaugeNoData]: "sem dado no filtro atual",

  [CanConsumptionMessages.tileVolume]: "Volume transportado",
  [CanConsumptionMessages.tileVolumeFoot]: "{{travels}} viagens no período",
  [CanConsumptionMessages.tileFuel]: "Combustível consumido",
  [CanConsumptionMessages.tileFuelFoot]: "{{distance}} km percorridos",
  [CanConsumptionMessages.tileFuelInside]: "Combustível dentro das viagens",
  [CanConsumptionMessages.tileFuelInsideFoot]: "{{percent}}% do total",
  [CanConsumptionMessages.tileFuelBetween]: "Combustível entre viagens",
  [CanConsumptionMessages.tileFuelBetweenFoot]: "todo consumo fora da viagem · {{percent}}% do total",
  [CanConsumptionMessages.tileFuelBetweenHint]: "Medido pelo contador do próprio veículo, do fim de uma viagem até o "
    + "início da próxima — sem filtro de local nem de velocidade. Entra tudo o que foi queimado fora da viagem: marcha "
    + "lenta e espera no pátio, retorno vazio, abastecimento, manutenção e qualquer outro deslocamento. Com filtro por "
    + "central, cada intervalo é atribuído à central da viagem seguinte.",
  [CanConsumptionMessages.tileHoursBetween]: "Motor ligado entre viagens",
  [CanConsumptionMessages.tileHoursBetweenFoot]: "{{idle}} em marcha lenta",
  [CanConsumptionMessages.tileHoursBetweenHint]: "Tempo com o motor funcionando fora da viagem — a régua dos "
    + "litros ao lado. Zero aqui é medição, não ausência: significa que a frota desligou o motor no pátio.",
  [CanConsumptionMessages.tileAvgKmPerTravel]: "Distância média por viagem",
  [CanConsumptionMessages.tileAvgKmPerTravelFoot]: "odômetro CAN das viagens do período",
  [CanConsumptionMessages.tileAvgSpeed]: "Velocidade média",
  [CanConsumptionMessages.tileAvgSpeedFoot]: "média ponderada por viagem",
  [CanConsumptionMessages.tileAvgTravelTime]: "Tempo médio por viagem",
  [CanConsumptionMessages.tileAvgTravelTimeFoot]: "da saída da usina ao fim da viagem",
  [CanConsumptionMessages.tileAttention]: "Equipamentos em atenção",
  [CanConsumptionMessages.tileAttentionFoot]: "acima do limite de {{metric}}",

  [CanConsumptionMessages.rankingTitle]: "Ranking por veículo",
  [CanConsumptionMessages.rankingSubtitle]: "Cada barra é um veículo. A linha marca a mediana da frota.",
  [CanConsumptionMessages.rankingMetricLabel]: "Indicador do ranking",
  [CanConsumptionMessages.rankingFallbackNote]: "sem dados de {{metric}} neste filtro — exibindo {{fallback}}",
  [CanConsumptionMessages.rankingEmpty]: "Sem dados de {{metric}} para o filtro atual.",

  [CanConsumptionMessages.dailyTitle]: "Dia a dia",
  [CanConsumptionMessages.dailySubtitle]: "Volume transportado por dia e o consumo médio correspondente.",
  [CanConsumptionMessages.dailyFoot]: "Barras: {{bars}} · números: {{metric}} ({{unit}})",
  [CanConsumptionMessages.dailyBarsVolume]: "volume transportado (m³)",
  [CanConsumptionMessages.dailyBarsFuel]: "combustível (L)",
  [CanConsumptionMessages.dailyNoOperation]: "sem operação",
  [CanConsumptionMessages.dailyConsolidating]: "ainda consolidando",
  [CanConsumptionMessages.dailyConsolidatingLegend]:
    "Dia hachurado: ainda consolidando. A integração das notas leva 1 a 2 dias, então o volume do dia ainda pode subir e o consumo por m³ "
    + "aparece inflado.",

  [CanConsumptionMessages.plantsTitle]: "Consumo por central",
  [CanConsumptionMessages.plantsSubtitle]:
    "Cada viagem pertence à central onde carregou; quando não sai de uma usina, à central de alocação do veículo. "
    + "O combustível entre viagens segue a viagem seguinte.",
  [CanConsumptionMessages.plantsNoPlantRow]: "Sem central",
  [CanConsumptionMessages.columnPlant]: "Central",

  [CanConsumptionMessages.tableTitle]: "Desempenho por veículo",
  [CanConsumptionMessages.columnVehicle]: "Veículo",
  [CanConsumptionMessages.columnVehicleType]: "Tipo",
  [CanConsumptionMessages.columnPlants]: "Centrais",
  [CanConsumptionMessages.columnTravels]: "Viagens",
  [CanConsumptionMessages.columnVolume]: "Volume transportado (m³)",
  [CanConsumptionMessages.columnDistance]: "Distância (km)",
  [CanConsumptionMessages.columnFuel]: "Combustível (L)",
  [CanConsumptionMessages.columnAvgKmPerTravel]: "Distância média (km/viagem)",
  [CanConsumptionMessages.columnAvgSpeed]: "Velocidade média (km/h)",
  [CanConsumptionMessages.columnAvgTravelTime]: "Tempo médio (h:mm)",
  [CanConsumptionMessages.tableLowSample]: "poucas viagens",
  [CanConsumptionMessages.tableEmpty]: "Nenhum equipamento no período e nos filtros selecionados.",
  [CanConsumptionMessages.legendBest]: "Melhor",
  [CanConsumptionMessages.legendWorst]: "Pior",
  [CanConsumptionMessages.legendHigherIsBetter]: "Em KM por litro, quanto maior o número, melhor.",
  [CanConsumptionMessages.legendNoColor]:
    "Célula sem cor: sem dado no período ou menos de {{minTravels}} viagens — base pequena não entra em ranking nem em alerta.",

  [CanConsumptionMessages.limitsTitle]: "Limites de alerta",
  [CanConsumptionMessages.limitsSubtitle]:
    "Defina, para cada indicador, a partir de que valor um veículo merece atenção. As faixas dos gráficos de bordo e as cores da tabela seguem "
    + "estes limites.",
  [CanConsumptionMessages.limitsWarn]: "Atenção",
  [CanConsumptionMessages.limitsCritical]: "Crítico",
  [CanConsumptionMessages.limitsFleetMedian]: "mediana da frota {{value}}",
  [CanConsumptionMessages.limitsReset]: "Restaurar padrões",
  [CanConsumptionMessages.limitsDone]: "Concluir",
  [CanConsumptionMessages.limitsClose]: "Fechar"
};

export const messages = canConsumptionMessages;
